import React, { useEffect, useState} from 'react';

import {  BreadCrumb, ListLayout } from './containers/Layout.jsx';
import { TableRow, TableCell, Button, TableHead, TableBody, Typography, TextField, AppBar, Tabs, Tab, Box, Card, Grid, IconButton, Menu, MenuItem } from '@material-ui/core';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import { EditRounded, MenuRounded } from '@material-ui/icons';
import NewBin from './Recycling/NewBin.jsx';
import SingleBin from './Recycling/SingleBin.jsx';
import { toast } from 'react-toastify';
import { BIN_TYPES } from './products/SubProducts/FormSubProduct.jsx';
import { isEmpty } from 'lodash-es';

const Recycling = (props) => {

    const [state, setState] = useState({ 
        singleBIN:{},
        bin:{},
        openDetails: false,
        page: "list",
        view: "",
        breadcrumb:"",
        headerMenu: "ALL",
        notif:{
            title:"", 
            type:"", 
            message:"",
            show:false,
        },
        anchorEl: null,
        BINS: {},
    })

    useEffect(() => {
        updateBinList()
    }, []);

    const updateBinList = async() =>{
        const req = await fetch("/stocks/getList/other",{
            method: "POST",
            headers: { 
                'Content-Type': 'application/json',
            },
            body:JSON.stringify({
                page: "bins"
            }),
            credentials: 'same-origin',
        })
        let res = await req.json()
        console.log('====================================');
        console.log({res});
        console.log('====================================');
        if (res){
            if (res.error) {
                toast.error("ERROR " + res.error)
                console.log('====================================');
                console.log("[ERROR]", res.error);
                console.log('====================================');
            } else {
                setState(prevState => ({...prevState,
                   BINS: res
               }))
            }
        }
    }
    const handleClose = () => {
        setState(prevState => ({...prevState,
            page:"list",
            breadcrumb:"",
            anchorEl: null,
            view: "",
            singleBIN: {}
        }));
    }
    const handleUpdate = () =>{
        updateBinList()
    }
    const openMenu = (event) => {
        setState(prevState => ({...prevState, anchorEl: event.currentTarget }));
    };
    
    const closeMenu = () => {
        setState(prevState => ({...prevState, anchorEl: null }));
    };
        const { BINS } = state

        return (
            <CardPage 
                title="Recyclage" 
                storehouse
                action={
                    <Box>
                        {state.page === "list" && 
                            <Button 
                                color="primary" 
                                variant="contained"
                                onClick={ ()=> setState(prevState => ({...prevState,view: "newBin", breadcrumb:"Nouveau"})) }
                            >
                                Nouveau Bac
                            </Button>
                        }
                        {/* <IconButton 
                            aria-controls="simple-menu"
                            onClick={openMenu}
                        >
                            <MenuRounded />
                        </IconButton>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            getContentAnchorEl={null}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={closeMenu}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={() => setState({page: "new", breadcrumb:"Nouveau"})}>Nouveau BIN</MenuItem>
                            <MenuItem onClick={() => setState({view: "newBin" })}>Nouveau bac de recyclage</MenuItem>
                        </Menu> */}
                    </Box>
                }
            >
                <BreadCrumb breadcrumb={state.breadcrumb} title="BIN" back={handleClose} />
                {/* {props.state.fetching && <Spin />} */}
                
                {state.view === "newBin" &&
                    <NewBin 
                        {...props} 
                        closeAll={handleClose} 
                        handleUpdate={handleUpdate} 
                    />
                }
                {state.view === "updateBin" &&
                    <NewBin 
                        {...props} 
                        update
                        bin={state.bin}
                        closeAll={handleClose} 
                        handleUpdate={handleUpdate} 
                    />
                }
                {state.view === "singleBin" && !isEmpty(state.singleBIN) &&
                    <SingleBin 
                        {...props} 
                        bin={state.singleBIN}
                        closeAll={handleClose} 
                    />
                }
                {/* {state.page === "suivi" && 
                    <InfoBIN 
                        closePopup={ 
                            () => setState({ page: "list", bin:{} })
                        }
                        bin={state.bin}
                        productName={PRODUCTS[state.bin.bin_product_id].name}
                        productBrand={PRODUCTS[state.bin.bin_product_id].marque}
                        updateSav={()=>props.updateSav(state.bin)}
                        notif={props.notif}
                        header={state.headerMenu}
                        fetchSchemas={props.fetchSavSchemas}
                        BIN_SCHEMAS={props.BIN_SCHEMAS}
                    />
                } */}
                
                   
                {state.page === "list" &&
                <Box>
                    <ListLayout className="table dataTable clickableRow">
                        <TableHead>
                            <TableRow>
                                <TableCell component="th"  style={{minWidth: "150px"}}>ID</TableCell>
                                <TableCell component="th" >Nom du Bac</TableCell>
                                <TableCell component="th" >Type</TableCell>
                                <TableCell component="th" >Bac Partagée</TableCell>
                                <TableCell component="th" >Options</TableCell>
                                {/* <TableCell component="th" >Date du Retour</TableCell>
                                <TableCell component="th" >Dernière action</TableCell>
                                <TableCell component="th" >Shop</TableCell>
                                <TableCell component="th" >Commentaire</TableCell>
                                <TableCell component="th" >Statut</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.values(state.BINS).map( item => (
                                <TableRow 
                                    key={item.id} 
                                    
                                    hover
                                >
                                    <TableCell ><b>{item.id.slice(0,13)}</b></TableCell> 
                                    <TableCell ><a href="#" onClick={  () => setState(prevState => ({...prevState, singleBIN:item, view: "singleBin" })) }>{item.bin_name}</a></TableCell>
                                    <TableCell >{BIN_TYPES[item.bin_type]}</TableCell>
                                    <TableCell ><b>{item.bin_share_id === "" ? "NON":"OUI"}</b></TableCell> 
                                    <TableCell >
                                        <IconButton onClick={() => setState(prevState => ({...prevState,view:"updateBin", bin : item}))}>
                                            <EditRounded />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ) )}
                        </TableBody>
                    </ListLayout>
                </Box>
                }
            </CardPage>
        )
}

export default Recycling;
